<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3 py-3">
          <CommonPartialSelectFromTable
              v-model="currentItem.attribute_uid"
              :label="$t('spec_attr')"
              dto-list-query="SpecAttrListQueryDTO"
              store-name="SelectSpecAttr"
              :sort-by="['group', 'name']"
              item-text="group_name"
              class="mt-3"
              :readonly="true"
          >
          </CommonPartialSelectFromTable>
          <CommonPartialSelectFromTable
              v-model="currentItem.component_uid"
              label="MPN"
              dto-list-query="ComponentShortListQueryDTO"
              store-name="SelectComponent"
              :sort-by="['article_display', 'alias']"
              item-text="alias_article"
              class="mt-3"
              :readonly="true"
          >
          </CommonPartialSelectFromTable>
          <v-radio-group v-model="currentItem.value_type" row @input="onChanged()">
            <v-radio label="integer" value="integer" ></v-radio>
            <v-radio label="float" value="float" ></v-radio>
            <v-radio label="text" value="text" ></v-radio>
          </v-radio-group>
          <CommonFieldString
              v-if="currentItem.value_type === 'integer'"
              v-model="currentItem.value_integer"
              label="Integer value"
              @input="onChanged()"
          ></CommonFieldString>
          <CommonFieldString
              v-if="currentItem.value_type === 'float'"
              v-model="currentItem.value_float"
              label="Float value"
              @input="onChanged()"
          ></CommonFieldString>
          <CommonFieldString
              v-if="currentItem.value_type === 'text'"
              v-model="currentItem.value_text"
              label="Text value"
              @input="onChanged()"
          ></CommonFieldString>
          <v-checkbox
              dense
              v-model="currentItem.manual_changed"
              outlined
              :label="$t('manual_changed')"
              :readonly="currentItem.manual_changed === false"
              :disabled="currentItem.manual_changed === false"
          >
          </v-checkbox>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonFieldString from "@/components/Common/CommonFieldString";

export default {
  name: "CoreSpecAttrComponentDetail",

  props: {
    uidItem: {default: null},
    embedded: {default: false},
    storeName: {type: [String], default: 'SpecAttrComponentDetail'},
    dtoDetailQuery: {default: 'SpecAttrComponentDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SpecAttrComponentActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SpecAttrComponentSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'SpecAttrComponentValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'SpecAttrComponentDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'SpecAttrComponentTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {
    onChanged() {
      // console.log('onChanged')
      this.currentItem.manual_changed = true
    },
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>